/**
 * Clershion · freccia di navigazione che segue il cursore sulla foto
 * principale del prodotto (solo mouse/desktop).
 * Passando il mouse sulla meta' sinistra della foto appare una freccia
 * verso sinistra, sulla meta' destra una freccia verso destra; cliccando
 * si passa alla foto precedente/successiva.
 *
 * Nota tecnica: su desktop, col layout "thumbnail_slider", Dawn nasconde
 * (display:none) tutte le slide tranne quella attiva - i pulsanti nativi
 * prev/next fanno solo uno scroll, che su desktop non ha alcun effetto
 * visibile (per questo Dawn li nasconde su desktop). Il meccanismo giusto
 * e' lo stesso che usa un click su una miniatura: il metodo
 * "setActiveMedia" del custom element <media-gallery>.
 */
(function () {
  function setupGallery(mediaGallery) {
    if (mediaGallery.dataset.clershionNavReady) return;
    if (typeof mediaGallery.setActiveMedia !== 'function') return;

    var slider = mediaGallery.querySelector('slider-component[id^="GalleryViewer-"]');
    var track = slider && slider.querySelector('ul[id^="Slider-Gallery-"]');
    if (!track) return;

    var slides = Array.prototype.filter.call(track.children, function (el) {
      return el.classList && el.classList.contains('product__media-item');
    });
    if (slides.length < 2) return;

    mediaGallery.dataset.clershionNavReady = 'true';
    slider.style.position = slider.style.position || 'relative';

    // Disattiva il bottone nativo di Dawn che apre la modale a schermo
    // intero SOLO sulle slide immagine (i video/modelli 3D restano
    // cliccabili normalmente, cosi' i loro controlli nativi funzionano).
    track.querySelectorAll('.product__modal-opener--image').forEach(function (opener) {
      opener.style.pointerEvents = 'none';
    });

    var arrow = document.createElement('button');
    arrow.type = 'button';
    arrow.className = 'clershion-gallery-nav__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.tabIndex = -1;
    arrow.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>';
    slider.appendChild(arrow);

    var dir = 'next';
    var hovering = false;

    function activeIndex() {
      var idx = slides.findIndex(function (el) {
        return el.classList.contains('is-active');
      });
      return idx === -1 ? 0 : idx;
    }

    function isEdge(direction) {
      var idx = activeIndex();
      return direction === 'prev' ? idx <= 0 : idx >= slides.length - 1;
    }

    function goTo(direction) {
      var idx = activeIndex();
      var targetIndex = direction === 'prev' ? idx - 1 : idx + 1;
      if (targetIndex < 0 || targetIndex >= slides.length) return;
      mediaGallery.setActiveMedia(slides[targetIndex].dataset.mediaId, false);
    }

    track.addEventListener('mouseenter', function () {
      hovering = true;
    });

    track.addEventListener('mouseleave', function () {
      hovering = false;
      arrow.classList.remove('is-visible');
    });

    track.addEventListener('mousemove', function (e) {
      var trackRect = track.getBoundingClientRect();
      var sliderRect = slider.getBoundingClientRect();
      if (trackRect.width === 0) return;

      dir = e.clientX - trackRect.left < trackRect.width / 2 ? 'prev' : 'next';
      arrow.classList.toggle('clershion-gallery-nav__arrow--prev', dir === 'prev');
      arrow.classList.toggle('is-disabled', isEdge(dir));
      arrow.classList.add('is-visible');

      arrow.style.left = e.clientX - sliderRect.left + 'px';
      arrow.style.top = e.clientY - sliderRect.top + 'px';
    });

    track.addEventListener('click', function (e) {
      if (!hovering) return;
      var slide = e.target.closest('.product__media-item');
      // Video / modelli 3D: lascia funzionare i controlli nativi.
      if (slide && slide.classList.contains('product__media-item--full')) return;
      if (isEdge(dir)) return;
      goTo(dir);
    });
  }

  function init() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('media-gallery').forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
